import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function WhyChooseUsSection() {
  const valueProps = ['Truck-mounted state-of-the-art equipment', 'Safe for kids and pets', 'Competitive and transparent pricing', 'Locally owned and operated since day one'];
  return <section className="bg-light-gray overflow-hidden" data-id="element-187">
      <div className="flex flex-col lg:flex-row min-h-[600px]" data-id="element-188">
        {/* Left Image - Parallax */}
        <div className="w-full lg:w-1/2 min-h-[400px] lg:min-h-full" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80")',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      }} data-id="element-189" />

        {/* Right Content */}
        <div className="w-full lg:w-1/2 px-6 py-16 md:py-24 lg:px-16 flex flex-col justify-center" data-id="element-190">
          <div className="max-w-xl" data-id="element-191">
            <h2 className="font-heading text-3xl md:text-4xl font-bold italic text-navy mb-6 leading-tight" data-id="element-192">
              Simply Clean. Simply Safe. Simply the Best.
            </h2>
            <p className="text-gray-700 text-lg mb-8 leading-relaxed" data-id="element-193">
              With busy families, kids, and pets, it's nearly impossible to keep
              your flooring clean all the time. That's where we come in —
              Phoenix Tile & Carpet Cleaning helps protect the investment you've
              made in your home. Our full-service cleaning process removes deep
              stains and leaves your tile and carpet looking and smelling fresh.
            </p>

            <div className="space-y-4 mb-10" data-id="element-194">
              {valueProps.map((prop, index) => <div key={index} className="flex items-start gap-3" data-id="element-195">
                  <CheckCircleIcon className="text-red flex-shrink-0 mt-1" size={24} data-id="element-196" />
                  <span className="text-navy font-medium text-lg" data-id="element-197">{prop}</span>
                </div>)}
            </div>

            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-198">
              Schedule Your Cleaning
            </Button>
          </div>
        </div>
      </div>
    </section>;
}